"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
const tokens_1 = require("../styles/tokens");
const useWindowSize_1 = require("./useWindowSize");
// Ensures css mobile only styles are the same as JSX render conditions
const smallBreakpoint = parseInt(tokens_1.BREAKPOINTS.sm.replace("px", ""), 10);
const useIsMobile = () => {
    const windowSize = (0, useWindowSize_1.useWindowSize)();
    const isMobile = windowSize.width < smallBreakpoint;
    return isMobile;
};
exports.useIsMobile = useIsMobile;
//# sourceMappingURL=useIsMobile.js.map